<!--标签模块-->
<template>
    <div>
        <div class="input-box clearfix">
            <input type="text" placeholder="添加标签；多个标签可用空格分开，回车键添加" @keypress="addLabel($event)">
            <div class="labelling">贴标签（{{labelNum}}）</div>
        </div>
        <div class="label-container">
            <div class="label-box clearfix" v-show="obj.Labels && obj.Labels.length>0">
                <div class="fl label" v-for="(item1,index1) in obj.Labels" :key="index1">
                    {{item1}} <span class="close" @click="deleteLabel(index1)">×</span>
                </div>
                <div class="fl label copy" @click="copySign">复制</div>
            </div>
            <div class="label-box" v-show="localLabels && localLabels.length>0">
                <span class="fl">本地标签：</span>
                <div class="label-right clearfix">
                    <div class="fl label" v-for="(item1,index1) in localLabels" v-show="index1<localLabelShowNum" :key="index1" @click.stop="addLabel($event,index1,4)" :class="{active: obj.Labels.includes(item1)}">
                        {{item1}} <span class="close">+</span>
                    </div>
                    <div class="fl label more-label" v-show="localLabelShowNum<localLabels.length" @click="showMoreLabel(4)">更多 ∨</div>
                    <div class="fl label less-label" v-show="localLabelShowNum==localLabels.length && localLabels.length>labelsShowNum" @click="showLessLabel(4)">收起 ∧</div>
                </div>
            </div>
            <div class="label-box" v-show="DailyLabels && DailyLabels.length>0">
                <span class="fl">个人标签：</span>
                <div class="label-right clearfix">
                    <div class="fl label" v-for="(item1,index1) in DailyLabels" :key="index1" v-show="index1<dayLabelShowNum" @click.stop="addLabel($event,index1,2)" :class="{active: obj.Labels.includes(item1)}">
                        {{item1}} <span class="close">+</span>
                    </div>
                    <div class="fl label more-label" v-show="dayLabelShowNum<DailyLabels.length" @click="showMoreLabel(2)">更多 ∨</div>
                    <div class="fl label less-label" v-show="dayLabelShowNum==DailyLabels.length && DailyLabels.length>labelsShowNum" @click="showLessLabel(2)">收起 ∧</div>
                </div>
            </div>
            <div class="label-box" v-show="SystemLabels && SystemLabels.length>0">
                <span class="fl">系统推荐：</span>
                <div class="label-right clearfix">
                    <div class="fl label" v-for="(item1,index1) in SystemLabels" :key="index1" v-show="index1<systemLabelShowNum" @click.stop="addLabel($event,index1,3)" :class="{active: obj.Labels.includes(item1)}">
                        {{item1}} <span class="close">+</span>
                    </div>
                    <div class="fl label more-label" v-show="systemLabelShowNum<SystemLabels.length" @click="showMoreLabel(3)">更多 ∨</div>
                    <div class="fl label less-label" v-show="systemLabelShowNum==SystemLabels.length && SystemLabels.length>labelsShowNum" @click="showLessLabel(3)">收起 ∧</div>
                </div>
            </div>
            <div class="label-box" v-show="HotLabels && HotLabels.length>0">
                <span class="fl">热门标签：</span>
                <div class="label-right clearfix">
                    <div class="fl label" v-for="(item1,index1) in HotLabels" v-show="index1<hotLabelShowNum" :key="index1" @click.stop="addLabel($event,index1,1)" :class="{active: obj.Labels.includes(item1)}">
                        {{item1}} <span class="close">+</span>
                    </div>
                    <div class="fl label more-label" v-show="hotLabelShowNum<HotLabels.length" @click="showMoreLabel(1)">更多 ∨</div>
                    <div class="fl label less-label" v-show="hotLabelShowNum==HotLabels.length && HotLabels.length>labelsShowNum" @click="showLessLabel(1)">收起 ∧</div>
                </div>
            </div>
        </div>
        <textarea v-html="copyText" style="opacity: 0" ref="textarea"></textarea>
        <!-- 提示框 -->
        <Warn ref="warn"></Warn>
    </div>
</template>
<script>
import Warn from "./warn.vue"
import Clipboard from "clipboard"
export default {
    components: {
        Warn
    },
    props: {
        localLabels: {
            type: Array,
            default: function(){
                return []
            }
        },
        DailyLabels: {
            type: Array,
            default: function(){
                return []
            }
        },
        SystemLabels: {
            type: Array,
            default: function(){
                return []
            }
        },
        HotLabels: {
            type: Array,
            default: function(){
                return []
            }
        },
        obj: {    //单个对象
            type: Object,
            default: function(){
                return {}
            }
        }
    },
    data(){
        return {
            labelNum: 30,
            labelsShowNum: 5,
            localLabelShowNum: 5,
            dayLabelShowNum: 5,
            systemLabelShowNum: 5,
            hotLabelShowNum: 5,
            copyText: "",
        }
    },
    mounted(){
        let clipboard = new Clipboard(".copy",{
            text: ()=> this.copyText
        });
        clipboard.on('success',(e)=>{
            this.$refs.warn.message("复制成功!");
        })
    },
    methods: {
        //copy 标签
        copySign(){ 
            console.log(this.$parent.fileShareList);
            this.$parent.fileShareList.map((item)=>{
                this.obj.Labels.map(eve => {
                    if(item.Labels.indexOf(eve)==-1){
                        item.Labels.push(eve)
                        console.log(item.Labels);
                    }
                })
            })
        },
        //添加标签
      addLabel(el,index1,type){
        if(!index1 && index1!=0){     //输入添加标签
            let code = el.keyCode;
            let val = el.target.value;
            if(code==13 && val!=""){
                let arr = this.trim(val).split(" ");
                let repeatArr = [];
                for(let i=0; i<arr.length; i++){
                    let str = this.addLabelToList(arr[i],this.obj);
                    if(str){
                        repeatArr.push(str);
                    }
                }
                if(repeatArr.length>0){
                    this.$refs.warn.message("已添加 "+repeatArr.join('、')+" 标签!");
                }
                el.target.value = "";
            }
        }else{      //选择添加标签
            let val = "";
            if(type==1){    //热门
                val = this.HotLabels[index1];
            }else if(type==2){  //常用
                val = this.DailyLabels[index1];
            }else if(type==3){
                val = this.SystemLabels[index1];
            }else if(type==4){
                val = this.localLabels[index1];
            }
            let str = this.addLabelToList(val,this.obj);
            if(str){
                this.$refs.warn.message("已添加 "+str+" 标签!");
            }
        }
      },
      //添加标签到数组中
      addLabelToList(val,obj){
        let labelList = obj.Labels;
        let len = labelList.length; //现有标签个数
        if(labelList.includes(val)){
            return val;
        }
        if(len<this.labelNum){
            obj.Labels.push(val);
        }else{
            //弹出提示,不能超过可贴标签数
            this.$refs.warn.message("已达到可贴标签数量!");
        }
      },
      //删除标签
      deleteLabel(index1){
          this.obj.Labels.splice(index1,1);
      },
      //显示更多热门标签
      showMoreLabel(index1){
          if(index1==1){
              this.hotLabelShowNum = this.HotLabels.length;
          }else if(index1==2){
              this.dayLabelShowNum = this.DailyLabels.length;
          }else if(index1==3){
              this.systemLabelShowNum = this.SystemLabels.length;
          }else if(index1==4){
              this.localLabelShowNum = this.localLabels.length;
          }
      },
      //收起热么标签
      showLessLabel(index1){
          if(index1==1){
            this.hotLabelShowNum = 5;
          }else if(index1==2){
            this.dayLabelShowNum = 5;
          }else if(index1==3){
              this.systemLabelShowNum = 5;
          }else if(index1==4){
              this.localLabelShowNum = 5;
          }
      },
      //删除前后空格
      trim(str){
          str = str.replace(/(^\s*)|(\s*$)/g, '');
          return str.replace(/\s+/g, ' ');
      }
    },
    watch: {
        'obj.Labels': function(){
            this.copyText = this.obj.Labels.join(" ");
        }
    }
}
</script>
<style scoped>
.copy{
    background: #6699ff !important;
    color: #fff;
}
.input-box{
    height: 40px;
    line-height: 40px;
    margin-bottom: 15px;
    box-sizing: border-box;
    position: relative;
}
.input-box input{
    width: 100%;
    height: 100%;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    background-color: #f8f8f8;
    box-sizing: border-box;
    padding: 0 25px 0 15px;
}
.label-container{
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    border-bottom: 1px solid #e7e7e7;
}
.labelling{
    position: absolute;
    right: 20px;
    top: 0;
    height: 100%;
}
.label-box{
    margin-bottom: 15px;
    overflow:auto;
}
.label{
    line-height: 20px;
    height: 20px;
    padding: 0 12px;
    background-color: #e9e9e9;
    border-radius: 4px;
    margin: 0 10px 10px 0;
    cursor: pointer;
}
.label.active{
    background-color: #6699ff;
    color: #fff;
}
.label-right{
    margin-left: 76px;
}
.label .close{
    display: inline-block;
    font-size: 20px;
    vertical-align: middle;
    margin-top: -5px;
}
.more-label, .less-label{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/labels.vue